 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALF from '@/components/half'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DED from '@/components/ded'
 import FRONT from '@/components/front'
 import CONTENTS from '@/components/contents'
 import LIST from '@/components/list'
 import ACK from '@/components/ack'
 import ABB from '@/components/abb'
 import MAP from '@/components/map'
 import HALF1 from '@/components/half1'
 import INT from '@/components/int'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import EPI from '@/components/epi'
 import LOVE_2 from '@/components/love_2'
 import NOTES from '@/components/notes'
 import FURTHER from '@/components/further'
 import AUTHOR from '@/components/author'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/list",
 			"name" : "list",
 			"component" : LIST
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/abb",
 			"name" : "abb",
 			"component" : ABB
 		},
 		{
 			"path" : "/map",
 			"name" : "map",
 			"component" : MAP
 		},
 		{
 			"path" : "/half1",
 			"name" : "half1",
 			"component" : HALF1
 		},
 		{
 			"path" : "/int",
 			"name" : "int",
 			"component" : INT
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js